// removed by extract-text-webpack-plugin
module.exports = {"Center":"_2ymh4d5l4sSbcRwOjwY7z_"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Center/index.css
// module id = 811
// module chunks = 0